<form>
  <div class="full-width-container">
    <mat-form-field>
      <textarea matInput placeholder="Własny CSS" [(ngModel)]="domain.ownCssJs" name="ownCssJs" rows="20"></textarea>
    </mat-form-field>
  </div>
</form>
